import { CSSProperties, memo, useMemo } from 'react'
import cn from 'classnames'
import { IconSpinner } from 'components/IconSpinner'
import { Portal } from 'components/ui/Portal'

import s from './PageLoading.module.less'

interface IProps {
  className?: string
  isPortal?: boolean
  minHeight?: number
  position?: 'fixed' | 'absolute' | 'relative'
}

export const PageLoading = memo(function PageLoading({
  className,
  position = 'relative',
  minHeight = 300,
  isPortal = false
}: IProps) {
  const style = useMemo<CSSProperties>(
    () => ({
      minHeight
    }),
    [minHeight]
  )

  const content = (
    <div className={cn(s.container, s[position], className)} data-test-id="page-loader" style={style}>
      <div className={s.overlay}>
        <IconSpinner size="lg" />
      </div>
    </div>
  )

  return isPortal ? <Portal>{content}</Portal> : content
})
